var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charge-balance"},[_c('span',{staticClass:"amount"},[_vm._v("Saldo disponível "),_c('span',{class:['badge', _vm.statusVariant]},[_vm._v("R$ "+_vm._s(_vm.formatPrice(_vm.balance)))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d126a3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Charge/Balance.vue
// module id = null
// module chunks = 